import Dialog from '../../components/Dialog.jsx';
import Notice from '../../components/Notice.jsx';
import { roleLabel } from './people-format.jsx';

export function AssignAllDialog({ role, total, already, busy, onConfirm, onCancel }) {
  const gaining = total - already;
  return (
    <Dialog
      open
      title={`Assign ${roleLabel(role)} to everyone in the organization?`}
      onClose={onCancel}
      footer={(
        <>
          <button type="button" className="btn-secondary" onClick={onCancel} disabled={busy}>Cancel</button>
          <button type="button" className="btn-primary" disabled={busy} onClick={onConfirm}>
            {busy ? 'Assigning...' : `Assign to ${total} ${total === 1 ? 'member' : 'members'}`}
          </button>
        </>
      )}
    >
      <p>
        This grants {roleLabel(role)} to all {total} {total === 1 ? 'member' : 'members'} of this customer
        ({already === 0 ? 'none has it yet' : `${already} already ${already === 1 ? 'has' : 'have'} it, ${gaining} will gain it`}).
        Each grant is recorded in the audit log. The change applies at each person&apos;s next sign-in.
      </p>
    </Dialog>
  );
}

export function AssignAllResult({ result }) {
  const { granted, alreadyHad, failed, skipped = 0, failures = [], truncated, message } = result;
  const attention = failed > 0 || skipped > 0;
  return (
    <Notice
      tone={attention ? 'warn' : 'good'}
      role="status"
      titleAs="p"
      testId="assign-all-result"
      title={`${granted} granted, ${alreadyHad} already had it, ${failed} failed${skipped > 0 ? `, ${skipped} skipped` : ''}.`}
    >
      {skipped > 0 && <p className="mt-1 text-xs">{message ?? 'Time ran out before every member was processed. Repeat the call to finish the rest.'} Assign to everyone again to finish.</p>}
      {failed > 0 && (
        <p className="mt-1 text-xs">
          Could not update: {failures.map((f) => f.email).join(', ')}. Fix the cause and assign again; members who have the role are skipped.
        </p>
      )}
      {truncated && <p className="mt-1 text-xs">The member list was cut short, so some members may not have been included.</p>}
    </Notice>
  );
}
